export default "__VITE_ASSET__BoCCSMId__"